/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import { StateID } from '../StateManager/StateID';
import StateReference from '../StateManager/StateReference';
import InjectableComponent from '../Utility/Component/ComponentReference/InjectableComponent';
import NodeCollection from '../Utility/Component/ComponentReference/NodeCollection';
import CLog, { LogTypes } from '../Utility/ComponentLogger';
import Decorators from '../Utility/Decorators';
import Effect from './Effect';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass
export default abstract class NodeCollectionEffectBase extends Effect
{
    @property(StateReference)
    protected initState: StateReference = new StateReference(StateID.CheckRecall, false);

    @property({ override: true, type: InjectableComponent })
    protected reference: InjectableComponent<NodeCollection> = new InjectableComponent();

    protected setContexts(): void
    {
        super.setContexts();
        this.reference.SetContext(NodeCollection);
    }

    protected start(): void
    {
        super.start();

        if (!this.initState.Value)
        {
            CLog.error('No init state.', this, LogTypes.Initialization);
            return;
        }

        this.initState.Value.OnStateChange(this.onInitStateChange);
    }

    protected onDestroy(): void
    {
        if (this.initState.Value) { this.initState.Value.OffStateChange(this.onInitStateChange); }

        super.onDestroy();
    }

    @Decorators.BindThis()
    protected onInitStateChange(): boolean
    {
        this.initState.Value.OffStateChange(this.onInitStateChange);

        return this.reference.WithValue<boolean>(nodeRef =>
            {
                if (nodeRef.Nodes.length < 1)
                {
                    CLog.warn(`No node collection [${this.reference.InstanceID}] has 0 nodes.`,
                        LogTypes.Initialization, this);
                    return false;
                }
                return true;
            }, () =>
            {
                CLog.warn(`No node collection [${this.reference.InstanceID}] reference not found.`,
                            LogTypes.Initialization, this);
                return false;
            });
    }
}
